import { PageId } from '../../../constants';
import { BaseAddPage } from './base-add-page';
import { isBookingFormInstalled } from '../../editor-sdk-actions';

export class AddFormPage extends BaseAddPage {
  constructor(protected editorSDK, protected appToken, protected instance) {
    super(editorSDK, appToken, instance);
  }

  public async shouldAddPage(): Promise<boolean> {
    const bookingFormInstalled = await isBookingFormInstalled(this.editorSDK);

    return !bookingFormInstalled;
  }

  public async execute() {
    await this.addBookingsPage(PageId.BOOKINGS_FORM_PAGE);

    await this.createPageState(PageId.BOOKINGS_FORM_PAGE, 'bookingForm');
  }

  protected get widgetId() {
    return '985e6fc8-ce3f-4cf8-9b85-714c73f48695';
  }

  public get widgetName() {
    return 'AddFormPage';
  }

  public get stepTranslate() {
    return 'form-page-migration.progress-bar.step-1';
  }
}
